// extracted by mini-css-extract-plugin
module.exports = {"newHeaderWrapper":"_1xR7t","overrideBackground":"_3bKdO","apps-count":"_14Y5Q","appsCount":"_14Y5Q","mobileHeaderSpacing":"_1BU-z"};